import Modules from "./Modules";
import NewFooter from "./new-footer";
function Products() {
    return (
        <div className="products-departament">
            <Modules />
            <NewFooter />
        </div>
    )
}
export default Products;

